/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Support_ChatInputs */



/**
* | output |
* | --- |
* | "Live Support Chat" |
*
* @param {Live_Support_ChatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_support_chat = /** @type {((inputs?: Live_Support_ChatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Support_ChatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chat de support en direct")
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Support-Chat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chat di supporto in tempo reale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Чат онлайн-поддержки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Chat de soporte en vivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在线客服聊天")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブサポートチャット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव सपोर्ट चैट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Chat de suporte ao vivo")
	return /** @type {LocalizedString} */ ("Live Support Chat")
});